// extracted by css-extract-rspack-plugin
export default {"BaseCell":"repo-searcher-module__BaseCell__L9Kbvoo","Box":"repo-searcher-module__Box__nv5hC13","renderedInput":"repo-searcher-module__renderedInput__iidjbYr"};